import { BinIcon } from "../../../../components/icon/Icon.jsx";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import { BonusWithdrawPanelStyled } from "./styled/BonusWithdrawPanelStyled.js";
import { memo } from "react";
import classNames from "classnames";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";
import { getWelcomeBonusActive } from "../../bonusesSelectors";

export const BonusWithdrawPanel = memo(({bonusActive, className, withdrawAmount}) => {
    const {getLangPath} = useLangContext();
    const preliminaryBonusAmount = withdrawAmount * bonusActive?.percent / 100;
    const bonusAmount = bonusActive?.credit < preliminaryBonusAmount ? bonusActive?.credit : preliminaryBonusAmount;
    return !!bonusActive && (
        <div className={classNames("d-flex flex-column", className)}>
            <Alert variant={'warning'} className="mb-3">
                <BinIcon name={'IcExclamationMarkTriangle'}/>
                <span>{getLangPath('bonuses.warning')}</span>
            </Alert>
            <BonusWithdrawPanelStyled>
                <div className="d-flex justify-content-between mb-1">
                    <span>{getLangPath('transactions.type.withdrawal')}</span>
                    <span>${withdrawAmount || 0}</span>
                </div>
                <div className="d-flex justify-content-between">
                    <span>{getLangPath('transactions.type.bonus_reduce')}</span>
                    <span>${bonusAmount}</span>
                </div>
                <hr className="my-2" style={{backgroundColor: 'var(--color-surface-secondary)', opacity: 1}}/>
                <div className="d-flex justify-content-between" style={{fontWeight: '600'}}>
                    <span>{getLangPath('bonuses.free_margin_reduction')}</span>
                    <span style={{fontSize: '16px', color: 'var(--color-white)'}}>
                            ${bonusAmount + +withdrawAmount}
                        </span>
                </div>
            </BonusWithdrawPanelStyled>
        </div>
    );
})

const mapStateToProps = createStructuredSelector({
    bonusActive: getWelcomeBonusActive,
})

export default connect(mapStateToProps)(BonusWithdrawPanel)
